import { Button, Form, Input, InputNumber, message, Select, Modal } from 'antd';
import { FormComponentProps, FormItemProps } from 'antd/lib/form';
// import TextArea from 'antd/lib/input/TextArea';
import * as React from 'react';
import { MedicineInfoCategory } from 'src/constants/enum';
import {
  IMallCPMDetail,
  IMallPharmacyDetail,
  IMallWesMedicineSpecification,
  IMallWesternMedicineEdit,
  IMedicineCatLog,
  IWesterMedCheckExistsQuery,
  IProductMapEntity,
  IMallBrand,
  MedicineUnitLight,
} from 'src/entity/MallEntity';
import I18N from 'src/services/I18NService';
import * as uuid from 'uuid';
import { MallService } from '../../../services/MallService';
import { WordService } from '../../../services/WordService';
import { EnumOrderType } from 'src/constants/Order';
import { IMedicineCatLogSearch, IWestApproachWay, IWestDosageForm, IWestMedicineFrequency, IWestTakeUnit } from 'src/entity/SearchEntity';
import debounce from 'lodash/debounce';
import WesternMedicineSpecification from './WesternMedicineSpecification';
import UpLoadImg from 'src/components/common/UpLoadImg';
import UpLoadListImg from 'src/components/common/UpLoadListImg';
import RicheEditor from 'src/components/common/RichEditor';
import { CpmBucketParam, } from 'src/utils/upload';
import FlexApiService, { IBucketInfo, CreateBucketParam, defaultBucketParam } from 'src/services/FlexApiService';
import MedicineService from 'src/services/MedicineService';

const confirm = Modal.confirm;

interface ITempMedicineForm extends Partial<IMallWesternMedicineEdit> {
  specificationGroup: IMallWesMedicineSpecification;
  preparation: 'true' | 'false';
}

interface IMedicineEditProps extends FormComponentProps {
  isAgent: boolean;
  medicineInfo: IMallCPMDetail | undefined;
  /** 类目CODE */
  category: string;
  pharmacyList: IMallPharmacyDetail[];
  /** 服用单位 */
  takeUnitList: IWestTakeUnit[];
  /** 剂型 */
  dosageFormList: IWestDosageForm[];
  /** 给药途径 */
  approachWayList: IWestApproachWay[];
  /** 用药频次 */
  medicineFrequencyList: IWestMedicineFrequency[];
  /** 品牌 */
  brandList: IMallBrand[];
  cbEdit(): void;
}

interface IMedicineEditState {
  loadingBtn: boolean;
  /** 药库选择 */
  pharmacy: IMallPharmacyDetail | undefined;
  /** 西/中成药字典数据 */
  medicineCatLog: IMedicineCatLog[];
  /** 选中字典 */
  catLogValue: string | undefined;
  /** 脉景品名 */
  productMap: IProductMapEntity[];
  /** bucketInfo */
  bucket: IBucketInfo | undefined;
  /** 零售单位/中成药服用单位/批发单位 */
  fullUnitList: MedicineUnitLight[]
}

class WesternMedicineEdit extends React.Component<IMedicineEditProps, IMedicineEditState> {
  constructor(props: IMedicineEditProps) {
    super(props);
    this.state = {
      loadingBtn: false,
      // hasPriceChangeApply: false,
      // specificationDisabled: !!props.medicineInfo,
      pharmacy: undefined,
      medicineCatLog: [],
      catLogValue: undefined,
      productMap: [],
      bucket: undefined,
      fullUnitList: []
    } as IMedicineEditState;
    this.searchMedicineCatLog = debounce(this.searchMedicineCatLog, 800);
    this.initBucketInfo();
  }

  async componentDidMount() {
    const { medicineInfo } = this.props;
    let pharmacy: IMallPharmacyDetail | undefined;
    if (!!medicineInfo) {
      pharmacy = this.props.pharmacyList.find((i) => i.uuid === medicineInfo.medicine_group.uuid);
    }
    const fullUnitList = await MedicineService.fetchMedicineUnitDict('CPM');
    this.setState({
      pharmacy,
      fullUnitList
    });
    /** 初始化脉景品名 */
    this.queryProductMap('');
  }

  componentWillUnmount() {
    this.setState = () => {
      return;
    };
  }

  handleSubmit = (e: React.SyntheticEvent) => {
    e.preventDefault();
    this.props.form.validateFields(async (err, values: ITempMedicineForm) => {
      if (!err) {
        if (this.state.loadingBtn) {
          return;
        }
        this.setState({
          loadingBtn: true,
        });
        let retailUnit: string | undefined;
        let wholesaleUnit: string | undefined;
        let equivalent: number | undefined;

        if (!!values.specificationGroup) {
          equivalent = values.specificationGroup.equivalent;
          retailUnit = values.specificationGroup.retail_unit;
          wholesaleUnit = values.specificationGroup.wholesale_unit;
        }
        const param: Partial<IWesterMedCheckExistsQuery> = {
          name: values.name,
          short_name: values.short_name,
          medicine_group_uuid: values.medicine_group,
          is_local: false,
        };
        const { medicineInfo, isAgent } = this.props;
        if (!!medicineInfo) {
          param.medicine_uuid = medicineInfo.uuid;
        }
        const hasExist = await MallService.checkExistsWesternMedicine(param);
        let data: Partial<IMallWesternMedicineEdit>;
        if (!!medicineInfo) {
          // 编辑
          data = {
            /** UUID */
            uuid: medicineInfo.uuid,
            /** 药品名称 */
            name: values.name,
            /** 药品简称 */
            short_name: values.short_name,
            /** 拼音 */
            pinyin: values.pinyin,
            /** 别名 */
            alias_name: values.alias_name,
            /** 商家药品编码 */
            medicine_code: values.medicine_code,
            /** 供应价 */
            supply_price: values.supply_price,
            /** 底价 */
            floor_price: values.floor_price,
            /** 生产商 */
            manufacturer: values.manufacturer,
            /** 产地 */
            production_place: values.production_place,
            /** 规格 */
            specification: values.specification,
            /** 零售单位 */
            retail_unit: retailUnit,
            /** 批发单位 */
            wholesale_unit: wholesaleUnit,
            /** 服用单位 */
            take_unit: values.take_unit,
            /** 起订量 */
            min_order_quantity: values.min_order_quantity,
            /** 订购单位 */
            order_unit: values.order_unit,
            /** 药效当量 */
            equivalent,
            /** 注册规格 */
            register_specification: values.register_specification,
            /** 中成药介绍 */
            description: values.description,
            /** 库存 */
            storage: values.storage,
            /** 新增入库 */
            add_storage: values.add_storage,
            /** 批号 */
            batch_number: values.batch_number,
            /** 剂型 */
            dosage_form: values.dosage_form,
            /** 给药途径 */
            approach_way: values.approach_way,
            /** 用药频次 */
            medicine_frequency: values.medicine_frequency,
            /** 类型 */
            category: values.category,
            /** 批准文号 */
            approval_number: values.approval_number,
            /** 脉景品名 */
            product_no: values.product_no || null,
            /** 主图 */
            main_img: values.main_img || null,
            /** 图片 */
            other_imgs: values.other_imgs || [],
            /** 院内制剂 */
            hospital_preparation: values.preparation === 'true' ? true : false,
            /** 药品介绍 */
            introduce: values.introduce,
            /** 品牌 */
            sku_brand: values.sku_brand || null,
          };
        } else {
          // 新增
          data = {
            /** 药品名称 */
            name: values.name,
            /** 药品简称 */
            short_name: values.short_name,
            /** 药库 */
            medicine_group: values.medicine_group,
            /** 拼音 */
            pinyin: values.pinyin,
            /** 别名 */
            alias_name: values.alias_name,
            /** 供应价 */
            supply_price: values.supply_price,
            /** 底价 */
            floor_price: values.floor_price,
            /** 商家药品编码 */
            medicine_code: values.medicine_code,
            /** 生产商 */
            manufacturer: values.manufacturer,
            /** 产地 */
            production_place: values.production_place,
            /** 规格 */
            specification: values.specification,
            /** 零售单位 */
            retail_unit: retailUnit,
            /** 批发单位 */
            wholesale_unit: wholesaleUnit,
            /** 服用单位 */
            take_unit: values.take_unit,
            /** 起订量 */
            min_order_quantity: values.min_order_quantity,
            /** 订购单位 */
            order_unit: values.order_unit,
            /** 药效当量 */
            equivalent,
            /** 注册规格 */
            register_specification: values.register_specification,
            /** 中成药介绍 */
            description: values.description,
            /** 库存 */
            storage: values.storage,
            /** 新增入库 */
            add_storage: values.add_storage,
            /** 批号 */
            batch_number: values.batch_number,
            /** 剂型 */
            dosage_form: values.dosage_form,
            /** 给药途径 */
            approach_way: values.approach_way,
            /** 用药频次 */
            medicine_frequency: values.medicine_frequency,
            /** 类型 */
            category: values.category,
            /** 批准文号 */
            approval_number: values.approval_number,
            /** 脉景品名 */
            product_no: values.product_no || null,
            /** 主图 */
            main_img: values.main_img || null,
            /** 图片 */
            other_imgs: values.other_imgs || [],
            /** 院内制剂 */
            hospital_preparation: values.preparation === 'true' ? true : false,
            /** 药品介绍 */
            introduce: values.introduce,
            /** 品牌 */
            sku_brand: values.sku_brand || null,
          };
        }
        const pharmacy = this.props.pharmacyList.find((i) => i.uuid === values.medicine_group);
        if (pharmacy && pharmacy.order_type === EnumOrderType.处方订单) {
          data.min_order_quantity = 1;
          data.order_unit = 1;
          data.coefficient = 1;
        }

        //  药品订购系数为修改值
        if (pharmacy && pharmacy.order_type === EnumOrderType.药品订单) {
          data.coefficient = values.coefficient;
        }
        if (hasExist) {
          confirm({
            title: ``,
            content: `${values.name}可能重复添加，确定依然要保存吗？`,
            okText: I18N.get('common_ok'),
            cancelText: I18N.get('common_cancel'),
            onOk: () => this.handleSubmitMedicine(data),
            onCancel: () => {
              this.setState({
                loadingBtn: false,
              });
            },
          });
          return;
        }
        // 特殊处理 解决后端该字段必填 防止报错

        await this.handleSubmitMedicine(data);
      }
    });
  };

  async handleSubmitMedicine(data: Partial<IMallWesternMedicineEdit>): Promise<void> {
    try {
      let res: IMallWesternMedicineEdit | undefined;

      if (!!data.uuid) {
        res = await MallService.updateWesternMedicine(data);
      } else {
        res = await MallService.createWesternMedicine(data);
      }
      if (!!res) {
        message.success(I18N.get('common_submit_success'));
        this.setState({
          loadingBtn: false,
        });
        this.props.cbEdit();
      }
    } catch (error) {
      this.setState({
        loadingBtn: false,
      });
      if (!!error.response) {
        message.error(JSON.stringify(error.response.data));
      } else {
        message.error(I18N.get('err_submit_failure'));
      }
    }
  }

  checkSpecification = (rule: any, value: IMallCPMDetail, callback: any) => {
    let noHaveError = true;
    try {
      if (value.equivalent > 0 && !!value.retail_unit && !!value.wholesale_unit) {
        noHaveError = false;
      }
      if (!noHaveError) {
        return callback();
      } else {
        callback(`${I18N.get('common_input')}包装规格`);
      }
    } catch (err) {
      callback(err);
    }
  };

  checkFloorPrice = (rule: any, value: number, callback: any) => {
    try {
      if (Number(value) <= (this.props.form.getFieldValue('supply_price') || 0)) {
        this.props.form.setFieldsValue({
          supply_price: this.props.form.getFieldValue('supply_price'),
        });
        return callback();
      }
      callback(`${I18N.get('med_buy_price')}${I18N.get('med_not_lower')}${I18N.get('med_preserve_price')}`);
    } catch (err) {
      callback(err);
    }
  };

  checkSupplyPrice = (rule: any, value: number, callback: any) => {
    try {
      if (Number(value) >= (this.props.form.getFieldValue('floor_price') || 0)) {
        this.props.form.setFieldsValue({
          floor_price: this.props.form.getFieldValue('floor_price'),
        });
        return callback();
      }
      callback(`${I18N.get('med_buy_price')}${I18N.get('med_not_lower')}${I18N.get('med_preserve_price')}`);
    } catch (err) {
      callback(err);
    }
  };

  onChangePharmacy = async (pharmacyUUID: string | undefined) => {
    if (!!pharmacyUUID) {
      const res = await MallService.searchMedicineDetail({
        medicine_group: pharmacyUUID,
        is_deleted: false,
        limit: 1,
        offset: 0,
      });
      const pharmacy = this.props.pharmacyList.find((i) => i.uuid === pharmacyUUID);
      if (!!res && (res.results || []).length > 0) {
        const exitMedicineInfo = res.results[0];
        if (!!exitMedicineInfo && !!exitMedicineInfo.uuid) {
          this.setState({
            pharmacy,
          });
        }
      } else {
        this.setState({
          pharmacy,
        });
      }
    }
  };

  /** 西/忠诚要字典搜索 */
  searchMedicineCatLog = (value: string) => {
    this.setState({
      medicineCatLog: [],
    });
    if (value.length < 2) {
      return;
    }
    const query: IMedicineCatLogSearch = {
      limit: 50,
      offset: 0,
      keywords: value,
    };
    // let data: IMedicineCatLog[] = [];
    MallService.searchMedicineCatLog(query).then((result) => {
      if (result) {
        this.setState({
          medicineCatLog: result,
        });
      }
    });
  };

  /** 字典选中回调 */
  medicineCatLogChange = async (value: any): Promise<void> => {
    const findResult = this.state.medicineCatLog.find((item) => item.uuid === value);
    let pinyin = this.props.form.getFieldValue('pinyin');
    if (findResult) {
      if (!!findResult.short_name) {
        const res = await WordService.getPinyinByDesc(findResult.short_name);
        if (!!res) {
          pinyin = res;
        }
      }
      this.props.form.setFieldsValue({
        approval_number: findResult.approval_number,
        category: findResult.category,
        name: findResult.name,
        short_name: findResult.short_name,
        pinyin,
        alias_name: findResult.alias,
        register_specification: findResult.regist_spec,
        manufacturer: findResult.manufactor,
        dosage_form: findResult.dosage_form || null,
        approach_way: findResult.dosage_route || null,
        take_unit: findResult.take_unit || null,
        medicine_frequency: findResult.medicine_frequency || null,
      });
    }
    this.setState({
      catLogValue: undefined,
      medicineCatLog: [],
    });
  };

  /**
   * 药品简称失去焦点触发
   *
   * @memberof MedicineEdit
   */
  shortNameOnBlur = async () => {
    const shortName = this.props.form.getFieldValue('short_name');
    const pinyin = this.props.form.getFieldValue('pinyin');
    if (!!shortName) {
      if (!pinyin) {
        const res = await WordService.getPinyinByDesc(shortName);
        if (!!res) {
          this.props.form.setFieldsValue({
            pinyin: res,
          });
        }
      }
    } else {
      this.props.form.setFieldsValue({
        pinyin: undefined,
      });
    }
  };

  /** 西药字典剂型显示 */
  matchDosageFormNameRender = (id: number): string => {
    const { dosageFormList } = this.props;
    let name = '';
    const match = dosageFormList.find((item) => item.id === id);
    if (match) {
      name = `（${match.name}）`;
    }
    return name;
  };

  /** 表单触发搜索脉景品名 */
  handleSearch = (keywords: string) => {
    if (keywords !== '') {
      this.queryProductMap(keywords);
    }
  };

  /** 模糊查询脉景品名 */
  async queryProductMap(key: string): Promise<void> {
    const productMap = await MallService.queryProductMap(key);
    this.setState({
      productMap,
    });
  }

  async initBucketInfo() {
    const bucket = await FlexApiService.createBucket(CpmBucketParam);
    if (bucket) {
      this.setState({
        bucket
      })
    }

  }

  render() {
    const { pharmacyList, medicineInfo, category, takeUnitList, dosageFormList, approachWayList, medicineFrequencyList, brandList } = this.props;
    const { getFieldDecorator } = this.props.form;
    const { medicineCatLog, productMap, bucket } = this.state;
    const formItemLayout: FormItemProps = {
      labelCol: { span: 6 },
      wrapperCol: { span: 15 },
    };
    const medicine_group = this.props.form.getFieldValue('medicine_group');
    const pharmacy = this.props.pharmacyList.find((i) => i.uuid === medicine_group);
    return (
      <div>
        <Form className="medicine-edit-form" onSubmit={this.handleSubmit}>
          {/* 脉景品名 */}
          <Form.Item label={I18N.get('med_spu_name')} {...formItemLayout}>
            {getFieldDecorator(`product_no`, {
              initialValue: !!medicineInfo ? medicineInfo.product_no : null,
            })(
              <Select
                showSearch={true}
                placeholder={`请输入药品名搜索，若无合适的可不填`}
                filterOption={false}
                defaultActiveFirstOption={false}
                onSearch={this.handleSearch}
                optionLabelProp="label"
                allowClear={true}
              >
                {productMap.map(f => <Select.Option key={f.uuid} value={f.uuid} label={f.simple_name} title={f.simple_name}>{f.name}</Select.Option>)}
              </Select>
            )}
          </Form.Item>
          {/* 西/中成药目录 */}
          <Form.Item label={'成药目录'} {...formItemLayout}>
            <Select
              showSearch={true}
              placeholder={`请输入药品名称或批准文号进行搜索导入`}
              filterOption={false}
              onSearch={this.searchMedicineCatLog}
              onChange={this.medicineCatLogChange}
              value={this.state.catLogValue}
              defaultActiveFirstOption={false}
            >
              {medicineCatLog.map((f) => {
                return (
                  <Select.Option key={`${f.uuid}_${f.name}`} value={f.uuid} label={f.approval_number + f.name}>
                    <div>
                      <span aria-label={f.approval_number + f.name}>{`${f.approval_number} ${f.name}${this.matchDosageFormNameRender(f.dosage_form)}`}</span>
                    </div>
                    <div style={{ color: '#888', fontSize: '12px', marginTop: '4px' }}>
                      <span>{`【注册规格】 ${f.regist_spec}`}</span>
                      <span>{`【厂家】 ${f.manufactor}`}</span>
                    </div>
                  </Select.Option>
                );
              })}
            </Select>
          </Form.Item>
          {/* 主图 */}
          <Form.Item label={'主图'} {...formItemLayout}>
            {getFieldDecorator(`main_img`, {
              rules: [{
                required: true,
                message: `请添加主图`,
              },
                // { validator: this.checkSpecification }
              ],
              initialValue: !!medicineInfo ? medicineInfo.main_img : '',
            })(<UpLoadImg key={uuid.v4()} bucketInfo={bucket} />)}
          </Form.Item>
          {/* 图片 */}
          <Form.Item label={'图片'} {...formItemLayout}>
            {getFieldDecorator(`other_imgs`, {
              rules: [{
                required: false,
              },
                // { validator: this.checkSpecification }
              ],
              initialValue: !!medicineInfo ? medicineInfo.other_imgs || [] : [],
            })(<UpLoadListImg key={uuid.v4()} bucketInfo={bucket} />)}
          </Form.Item>
          {/* 药品ID --编辑时显示 */}
          {!!medicineInfo && (
            <Form.Item {...formItemLayout} label={`${I18N.get('med_agent_code')}`}>
              {getFieldDecorator(`code`, {
                initialValue: medicineInfo.code,
              })(<Input disabled={true} />)}
            </Form.Item>
          )}
          {/* 批准文号 */}
          <Form.Item {...formItemLayout} label={'批准文号'}>
            {getFieldDecorator(`approval_number`, {
              initialValue: !!medicineInfo ? medicineInfo.approval_number : null,
            })(<Input maxLength={50} placeholder={`${I18N.get('common_input')}批准文号`} />)}
          </Form.Item>
          {/* 分类 */}
          <Form.Item {...formItemLayout} label={'分类'}>
            {getFieldDecorator(`category`, {
              rules: [
                {
                  required: true,
                  message: `${I18N.get('common_choose')}分类`,
                },
              ],
              initialValue: !!medicineInfo ? medicineInfo.category : null,
            })(
              <Select placeholder={`${I18N.get('common_choose')}分类`}>
                {MedicineInfoCategory.map((f) => {
                  return (
                    <Select.Option key={`${f.value}_${f.label}`} value={f.value}>
                      {f.label}
                    </Select.Option>
                  );
                })}
              </Select>
            )}
          </Form.Item>
          {/* 院内制剂 */}
          <Form.Item {...formItemLayout} label={'院内制剂'}>
            {getFieldDecorator(`preparation`, {
              rules: [
                {
                  required: true,
                  message: `${I18N.get('common_choose')}`,
                },
              ],
              initialValue: !!medicineInfo ? !!medicineInfo.hospital_preparation ? 'true' : 'false' : 'true',
            })(
              <Select placeholder={`${I18N.get('common_choose')}`}>
                <Select.Option key={`preparationTrue`} value={'true'}>是</Select.Option>
                <Select.Option key={`preparationFalse`} value={'false'}>否</Select.Option>
              </Select>
            )}
          </Form.Item>
          {/* 药库 */}
          <Form.Item label={I18N.get('common_pharmacy')} {...formItemLayout}>
            {getFieldDecorator(`medicine_group`, {
              rules: [
                {
                  required: true,
                  message: `${I18N.get('common_choose')}${I18N.get('common_pharmacy')}`,
                },
              ],
              initialValue: !!medicineInfo ? medicineInfo.medicine_group.uuid : null,
            })(
              <Select disabled={!!medicineInfo} placeholder={`${I18N.get('common_choose')}药库`}>
                {pharmacyList
                  .filter((t) => t.category_code === category && !t.is_deleted)
                  .map((f) => {
                    return (
                      <Select.Option key={`${f.uuid}_${f.name}`} value={f.uuid}>
                        {f.is_active ? f.name : `${f.name}(${I18N.get('common_status_disable')})`}
                      </Select.Option>
                    );
                  })}
              </Select>
            )}
          </Form.Item>

          {/* 药品全称 */}
          <Form.Item label={'药品全称'} {...formItemLayout}>
            {getFieldDecorator(`name`, {
              rules: [
                {
                  required: true,
                  message: `${I18N.get('common_input')}${I18N.get('med_agent_name')}`,
                },
              ],
              initialValue: !!medicineInfo ? medicineInfo.name : undefined,
            })(<Input name="medicine-edit-name" placeholder={`${I18N.get('common_input')}${I18N.get('med_agent_name')}`} maxLength={50} />)}
          </Form.Item>

          {/* 药品简称 */}
          <Form.Item label={I18N.get('med_short_name')} {...formItemLayout}>
            {getFieldDecorator(`short_name`, {
              rules: [
                {
                  required: true,
                  message: `${I18N.get('common_input')}${I18N.get('med_short_name')}`,
                },
              ],
              initialValue: !!medicineInfo ? medicineInfo.short_name : undefined,
            })(
              <Input
                name="medicine-edit-short-name"
                onBlur={this.shortNameOnBlur}
                placeholder={`${I18N.get('common_input')}${I18N.get('med_short_name')}`}
                maxLength={50}
              />
            )}
          </Form.Item>

          {/* 简称拼音 */}
          <Form.Item label={I18N.get('med_short_name_pinyin2')} {...formItemLayout}>
            {getFieldDecorator(`pinyin`, {
              rules: [
                {
                  required: true,
                  message: `${I18N.get('common_input')}${I18N.get('med_short_name_pinyin2')}`,
                },
              ],
              initialValue: !!medicineInfo ? medicineInfo.pinyin : null,
            })(<Input placeholder={`${I18N.get('common_input')}${I18N.get('med_short_name_pinyin2')}`} />)}
          </Form.Item>

          {/* 别名 */}
          <Form.Item label={'别名'} {...formItemLayout}>
            {getFieldDecorator(`alias_name`, {
              initialValue: !!medicineInfo ? medicineInfo.alias_name : null,
            })(<Input placeholder={`${I18N.get('common_input')}别名`} maxLength={50} />)}
          </Form.Item>

          {/* 商家药品编码 --中成药 */}
          <Form.Item label={I18N.get('med_medicine_code')} {...formItemLayout}>
            {getFieldDecorator(`medicine_code`, {
              initialValue: !!medicineInfo ? medicineInfo.medicine_code : null,
            })(<Input maxLength={30} placeholder={`${I18N.get('common_input')}${I18N.get('med_medicine_code')}`} />)}
          </Form.Item>

          {/* 注册规格 */}
          <Form.Item label={'注册规格'} {...formItemLayout}>
            {getFieldDecorator(`register_specification`, {
              initialValue: !!medicineInfo ? medicineInfo.register_specification : null,
            })(<Input placeholder={`${I18N.get('common_input')}注册规格`} disabled={true} />)}
          </Form.Item>

          {/* 药品规格*/}
          <Form.Item label={'药品规格'} {...formItemLayout}>
            {getFieldDecorator(`specification`, {
              rules: [
                {
                  required: true,
                  message: `${I18N.get('common_input')}药品规格`,
                },
              ],
              initialValue: !!medicineInfo ? medicineInfo.specification : '',
            })(<Input placeholder={`${I18N.get('common_input')}药品规格`} maxLength={30} />)}
          </Form.Item>

          {/* 规格/服用单位/零售单位/批发单位 */}
          {
            <Form.Item label={'包装规格'} {...formItemLayout}>
              {getFieldDecorator(`specificationGroup`, {
                rules: [{ required: true }, { validator: this.checkSpecification }],
                initialValue: {
                  equivalent: !!medicineInfo ? medicineInfo.equivalent : undefined,
                  retail_unit: !!medicineInfo ? medicineInfo.retail_unit : undefined,
                  wholesale_unit: !!medicineInfo ? medicineInfo.wholesale_unit : undefined,
                },
              })(<WesternMedicineSpecification key={uuid.v4()} fullUnitList={this.state.fullUnitList} />)}
            </Form.Item>
          }
          {/* 药品订购 系数 */}
          {pharmacy && pharmacy.order_type === EnumOrderType.药品订单 && (
            <Form.Item label={I18N.get('med_coefficient')} {...formItemLayout}>
              {getFieldDecorator(`coefficient`, {
                rules: [
                  {
                    required: true,
                    message: '请输入用于小包装零售时的价格转换系数',
                  },
                ],
                initialValue: !!medicineInfo ? medicineInfo.coefficient : null,
              })(
                <InputNumber
                  min={0.01}
                  precision={2}
                  max={10000}
                  style={{ width: '100%' }}
                  placeholder={`请输入用于小包装零售时的价格转换系数`}
                />
              )}
            </Form.Item>)}

          {/* 起订量 */}
          {pharmacy && pharmacy.order_type === EnumOrderType.药品订单 && (
            <Form.Item label={I18N.get('order_min_purchase_amount')} {...formItemLayout}>
              {getFieldDecorator(`min_order_quantity`, {
                rules: [
                  {
                    required: true,
                    message: `${I18N.get('common_input')}${I18N.get('order_min_purchase_amount')}`,
                  },
                ],
                initialValue: !!medicineInfo ? medicineInfo.min_order_quantity : null,
              })(
                <InputNumber
                  min={1}
                  precision={0}
                  max={99999}
                  style={{ width: '100%' }}
                  placeholder={`${I18N.get('common_input')}${I18N.get('order_min_purchase_amount')}`}
                />
              )}
            </Form.Item>
          )}
          {/* 订购单位 */}
          {pharmacy && pharmacy.order_type === EnumOrderType.药品订单 && (
            <Form.Item label={I18N.get('order_purchase_unit')} {...formItemLayout}>
              {getFieldDecorator(`order_unit`, {
                rules: [
                  {
                    required: true,
                    message: `${I18N.get('common_input')}${I18N.get('order_purchase_unit')}`,
                  },
                ],
                initialValue: !!medicineInfo ? medicineInfo.order_unit : null,
              })(<InputNumber min={1} precision={0} max={99999} style={{ width: '100%' }} placeholder={`${I18N.get('common_input')}${I18N.get('order_purchase_unit')}`} />)}
            </Form.Item>
          )}
          {/* 供货价 */}
          <Form.Item label={`${I18N.get('med_buy_price')}(￥)`} {...formItemLayout}>
            {getFieldDecorator(`supply_price`, {
              rules: [
                {
                  required: true,
                  message: `${I18N.get('common_input')}${I18N.get('med_buy_price')}`,
                },
                { validator: this.checkSupplyPrice },
              ],
              initialValue: !!medicineInfo ? medicineInfo.supply_price : null,
            })(
              <InputNumber
                min={0.0001}
                max={9999}
                precision={4}
                style={{ width: '100%' }}
                placeholder={`${I18N.get('common_input')}${I18N.get('med_buy_price')}`}
              />
            )}
          </Form.Item>
          {/* 底价 */}
          <Form.Item label={`${I18N.get('med_preserve_price')}(￥)`} {...formItemLayout}>
            {getFieldDecorator(`floor_price`, {
              rules: [
                {
                  required: true,
                  message: `${I18N.get('common_input')}${I18N.get('med_preserve_price')}`,
                },
                { validator: this.checkFloorPrice },
              ],
              initialValue: !!medicineInfo ? medicineInfo.floor_price : null,
            })(
              <InputNumber
                min={0.0001}
                max={9999}
                precision={4}
                style={{ width: '100%' }}
                placeholder={`${I18N.get('common_input')}${I18N.get('med_preserve_price')}`}
              />
            )}
          </Form.Item>
          {/* 生产商 */}
          <Form.Item label={I18N.get('med_manufacturer')} {...formItemLayout}>
            {getFieldDecorator(`manufacturer`, {
              rules: [
                {
                  required: true,
                  message: `${I18N.get('common_input')}${I18N.get('med_manufacturer')}`,
                },
              ],
              initialValue: !!medicineInfo ? medicineInfo.manufacturer : null,
            })(<Input placeholder={`${I18N.get('common_input')}${I18N.get('med_manufacturer')}`} maxLength={50} />)}
          </Form.Item>
          {/* 产地 */}
          <Form.Item label={I18N.get('med_origin_place')} {...formItemLayout}>
            {getFieldDecorator(`production_place`, {
              rules: [
                {
                  required: false,
                  message: `${I18N.get('common_input')}${I18N.get('med_origin_place')}`,
                },
              ],
              initialValue: !!medicineInfo ? medicineInfo.production_place : null,
            })(<Input placeholder={`${I18N.get('common_input')}${I18N.get('med_origin_place')}`} maxLength={50} />)}
          </Form.Item>
          {/* 品牌  */}
          <Form.Item label={I18N.get('pharmacy_brand')} {...formItemLayout}>
            {getFieldDecorator(`sku_brand`, {
              rules: [
                {
                  required: false,
                  message: `${I18N.get('common_choose')}${I18N.get('pharmacy_brand')}`,
                },
              ],
              initialValue: !!medicineInfo ? medicineInfo.sku_brand : null,
            })(
              <Select showSearch={true} placeholder={`${I18N.get('common_choose')}${I18N.get('pharmacy_brand')}`}>
                {brandList.map((f) => {
                  return (
                    <Select.Option key={`${f.id}_${f.name}`} value={f.id}>
                      {f.name}
                    </Select.Option>
                  );
                })}
              </Select>
            )}
          </Form.Item>
          {/* 剂型  */}
          <Form.Item label={I18N.get('pharmacy_dosage_form')} {...formItemLayout}>
            {getFieldDecorator(`dosage_form`, {
              rules: [
                {
                  required: false,
                  message: `${I18N.get('common_choose')}${I18N.get('pharmacy_dosage_form')}`,
                },
              ],
              initialValue: !!medicineInfo ? medicineInfo.dosage_form : null,
            })(
              <Select showSearch={true} placeholder={`${I18N.get('common_choose')}${I18N.get('pharmacy_dosage_form')}`}>
                {dosageFormList.map((f) => {
                  return (
                    <Select.Option key={`${f.id}_${f.name}`} value={f.id}>
                      {f.name}
                    </Select.Option>
                  );
                })}
              </Select>
            )}
          </Form.Item>

          {/* 给药途径  */}
          <Form.Item label={'给药途径'} {...formItemLayout}>
            {getFieldDecorator(`approach_way`, {
              rules: [
                {
                  required: false,
                  message: `${I18N.get('common_choose')}给药途径`,
                },
              ],
              initialValue: !!medicineInfo ? medicineInfo.approach_way : null,
            })(
              <Select showSearch={true} placeholder={`${I18N.get('common_choose')}给药途径`}>
                {approachWayList.map((f) => {
                  return (
                    <Select.Option key={`${f.id}_${f.name}`} value={f.id}>
                      {f.name}
                    </Select.Option>
                  );
                })}
              </Select>
            )}
          </Form.Item>

          {/* 服用单位 */}
          <Form.Item label={I18N.get('med_take_unit')} {...formItemLayout}>
            {getFieldDecorator(`take_unit`, {
              rules: [
                {
                  required: false,
                  message: `${I18N.get('common_choose')}${I18N.get('med_take_unit')}`,
                },
              ],
              initialValue: !!medicineInfo ? medicineInfo.take_unit : null,
            })(
              <Select showSearch={true} placeholder={`${I18N.get('common_choose')}${I18N.get('med_take_unit')}`}>
                {this.state.fullUnitList.map((unit) => {
                  return (
                    <Select.Option key={`${unit.id}`} value={unit.id}>
                      {unit.name}
                    </Select.Option>
                  );
                })}
              </Select>
            )}
          </Form.Item>

          {/* 用药频次 */}
          <Form.Item label={'用药频次'} {...formItemLayout}>
            {getFieldDecorator(`medicine_frequency`, {
              rules: [
                {
                  required: false,
                  message: `${I18N.get('common_choose')}用药频次`,
                },
              ],
              initialValue: !!medicineInfo ? medicineInfo.medicine_frequency : null,
            })(
              <Select showSearch={true} placeholder={`${I18N.get('common_choose')}用药频次`}>
                {medicineFrequencyList.map((f) => {
                  return (
                    <Select.Option key={`${f.id}_${f.frequency}`} value={f.id}>
                      {f.frequency}
                    </Select.Option>
                  );
                })}
              </Select>
            )}
          </Form.Item>

          {/* 批号 */}
          <Form.Item label={I18N.get('med_batch_number')} {...formItemLayout}>
            {getFieldDecorator(`batch_number`, {
              rules: [
                {
                  required: false,
                  message: `${I18N.get('common_input')}${I18N.get('med_batch_number')}`,
                },
              ],
              initialValue: !!medicineInfo ? medicineInfo.batch_number : null,
            })(<Input placeholder={`${I18N.get('common_input')}${I18N.get('med_batch_number')}`} maxLength={50} />)}
          </Form.Item>
          {/* 介绍 --中成药 */}
          {/* <Form.Item label={I18N.get('med_cpm_introduce')} {...formItemLayout}>
            {getFieldDecorator(`description`, {
              rules: [
                {
                  required: false,
                  message: `${I18N.get('common_input')}${I18N.get('med_cpm_introduce_detail')}`,
                },
              ],
              initialValue: !!medicineInfo ? (medicineInfo as IMallCPMDetail).description : null,
            })(<TextArea rows={4} maxLength={200} placeholder={`${I18N.get('common_input')}${I18N.get('med_cpm_introduce_detail')}`} />)}
          </Form.Item> */}

          {/* 药品介绍 */}
          <Form.Item label={`${I18N.get('med_agent')}${I18N.get('med_cpm_introduce')}`} {...formItemLayout}>
            {getFieldDecorator(`introduce`, {
              rules: [
                {
                  required: false,
                  // message: `${I18N.get('common_input')}${I18N.get('med_cpm_introduce_detail')}`,
                },
              ],
              initialValue: !!medicineInfo ? medicineInfo.introduce : '',
            })(<RicheEditor />)}
          </Form.Item>

          {medicineInfo && (
            <section
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                marginLeft: '139px',
                marginRight: '90px',
                marginBottom: '14px',
              }}
            >
              {/* 库存 */}
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <label style={{ width: '40px' }}> {I18N.get('common_storage')} :</label>
                <Input
                  style={{ flex: 1 }}
                  disabled={true}
                  value={medicineInfo.storage}
                  placeholder={`${I18N.get('common_input')}${I18N.get('common_storage')}`}
                />
              </div>
            </section>
          )}

          {/* 新增入库 */}
          <Form.Item label={I18N.get('common_add_storage')} {...formItemLayout}>
            {getFieldDecorator(`add_storage`, {
              initialValue: !!medicineInfo ? medicineInfo.add_storage : null,
            })(<InputNumber precision={0} style={{ width: '100%' }} placeholder={`${I18N.get('common_input')}${I18N.get('common_storage')}`} />)}
          </Form.Item>
          <Form.Item wrapperCol={{ span: 12, offset: 6 }}>
            <Button type="primary" htmlType="submit">
              {I18N.get('common_save')}
            </Button>
          </Form.Item>
        </Form>
      </div>
    );
  }
}

const WesternMedicineEditForm = Form.create<IMedicineEditProps>()(WesternMedicineEdit);
export default WesternMedicineEditForm;



// WEBPACK FOOTER //
// ./src/components/views/Mall/WesternMedicineEditForm.tsx